export * as size from "./size";
export const config = {
  rowHeight: 48,
  /**
   * react-grid-layout WidthProvider 提供的初始宽度
   * https://github.com/react-grid-layout/react-grid-layout/blob/788426d3470696e167800ce6757a89ac9d0d2777/lib/components/WidthProvider.jsx#L56
   */
  initWidth: 1280,
};
